// import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';
import Inputmask from 'inputmask';

window.dataLayer = window.dataLayer || [];

/* eslint no-plusplus: [2, { allowForLoopAfterthoughts: true }] */
/* eslint no-underscore-dangle: 0 */
/* eslint quote-props: ["error", "consistent"] */

window.jQuery = $; // for BED/Kentico script
let currentPaymentType;
let currentDonationAmount;

const isValidDonation = () => {
    const $form = $('.c-quick-donation-form');
    if ($form.length === 0) return true;

    const minAmount = $form.find('.js-donate').data('min-donate');
    const maxAmount = $form.find('.js-donate').data('max-donate');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $donateState = $form
        .find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-amount-input input');
    const $donateAmountField = $form
        .find(`.js-donate .donate-option[data-amount='${$donateAmount.val()}'][data-freq-mode='${$donateFreq.val()}']`);
    const $donateAmountInput = $form.find('.donate-amount-input');
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $errorCon = $form.find('.donate-error');
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const $donateMonthlyFreq = $form.find('.donate-monthly-btn:not(.monthly-text-off)');
    const donateFreqvalue = $donateFreq.val().toLowerCase();
    const donateMonthlyFreqValue = $form.find('.donate-monthly-btn').length ? $form.find('.donate-monthly-btn').data('freq').toLowerCase() : 'no-monthly';
    let message = '';
    let descMessage = '';
    let errorMessage = '';
    const $messageDesc = $form.find('.js-amount-desc p');

    // clear all selection state and message/error
    $donateState.removeClass('selected');
    $message.parent().removeClass('has-msg');
    $errorCon.removeClass('has-error');
    $buttonWraper.removeClass('Error');

    // freq
    $(`.js-donate .donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');

    if (donateFreqvalue === donateMonthlyFreqValue) {
        $donateMonthlyFreq.slideUp();
    } else {
        $donateMonthlyFreq.slideDown();
    }

    // if no freq selected, show error
    if ($donateFreq.val() === '') {
        errorMessage = $errorCon.data('error-donation-frequency-not-selected');
    }

    // amount
    if ($donateAmount.val() === '') {
        errorMessage = $errorCon.data('error-amount-missing');
    } else if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
        message = $donateAmountField.data('message');
        descMessage = message;
    } else {
        if ($donateAmount.val() !== '') {
            $form.find('.donate-amount-input input').addClass('selected');
        }

        if (minAmount <= $donateAmount.val() && maxAmount >= $donateAmount.val()) {
            message = '';
            descMessage = $donateAmountInput.data('message');
        } else {
            if ($donateAmount.val() > maxAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-max-amount') + maxAmount);
            }

            if ($donateAmount.val() < minAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-min-amount') + minAmount);
            }
        }
    }

    // emptying message
    $message.html('');
    $messageDesc.html('');

    // render message
    if (message !== '') {
        $message.html(`$${$donateAmount.val()} ${message}`).parent().addClass('has-msg');
    }

    // render descMessage
    if (descMessage !== '') {
        const donationType = $form.find('.js-donate').data(`donation-${$donateFreq.val().toLowerCase()}`);
        $messageDesc.html(`Your ${donationType} of <strong>$${$donateAmount.val()}</strong> ${descMessage}`);
    }

    // render errorMessage
    if (errorMessage !== '') $errorCon.addClass('has-error').html(errorMessage);

    // return true or show error
    if (errorMessage === '') return true;
    $buttonWraper.addClass('Error');
    return false;
};

// helper: select which form to validate
const validateForm = () => {
    if (isValidDonation()) {
        return true;
    }
    return false;
};

// avoid kentico onclick button run before validate
const removeKenticoOnclick = () => {
    const $form = $('.c-quick-donation-form');
    const $button = $form.find('.js-form-validate');
    if ($button.length === 0) return;

    if ($button.attr('onclick') !== undefined) {
        $button.addClass('js-click-to-submit-slider');
        $button.removeAttr('onclick');
    }
};

// get processing fee amount based on payment type and amount
const getProcessingFee = () => {
    const $form = $('.c-quick-donation-form');
    const $processingFeeAmount = $form.find('#CheckBoxContro-processing-fee #processing-amount');

    // call api if donation amount and payment type exists
    if (currentDonationAmount && currentPaymentType) {
        const $apiUrl = $form.find('#processing-fee-api').data('api-url');
        const paymentTypeQuery = {
            'paypal-payment': 'PayPal',
            'cc-form': 'CreditCard',
            'debit-form': 'DirectDebit'
        };
        const $queryUrl =
            `${$apiUrl}?amount=${currentDonationAmount}&paymenttype=${paymentTypeQuery[currentPaymentType]}`;

        fetch($queryUrl)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Request failed');
            })
            .then(jsonResponse => $processingFeeAmount.html(jsonResponse.data))
            .catch(err => {
                console.log(err);
            });
    }
};


// /* intro form bind
// * update payment form message - donate amount
// */
const initDonationFormUpdateAction = () => {
    const $form = $('.c-quick-donation-form');
    const $donateOptions = $form.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-monthly-btn');
    const $donateCustom = $form.find('.donate-amount-input input');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $errorCon = $form.find('.donate-error');
    const $amoutOptions = $form.find('.donate-amounts .donate-option');
    const $preSelectedOptions = $form.find('.donate-amounts .donate-option.selected');
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $iconHolder = $form.find('.donation-icon');
    const $recurringFields = $('#recurring-form');
    const $amountDesc = $form.find('.payment-details .js-amount-desc strong span');

    if ($form.length <= 0) return;

    if ($preSelectedOptions.length) {
        $donateAmount.val($preSelectedOptions.data('amount')).trigger('change');
        $donateCustom.val('');
        // update processing fee API call
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }

    // on donation freg change, show hide message/error, update processing fee API call
    $donateFreq.change(() => {
        const $option = $('.js-card-form-select select');

        isValidDonation();
        currentPaymentType = $option.find(':selected').data('form-id');
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }).change();

    // on donation amount change, show hide message/error, remove session storage, update processing fee API call
    $donateAmount.change(() => {
        isValidDonation();
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }).change();

    // on selection change, update donation
    $donateOptions.click(function (e) {
        e.preventDefault();
        const $el = $(this);

        if ($el.data('freq') !== undefined) {
            $donateFreq.val($el.data('freq')).trigger('change');
            // Show hide the donation amount options for the frequency selected
            $('.donate-amounts .donate-option').hide();
            $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).show();
            if (!$donateCustom.val()) {
                const lastFreqAmount = $donateFreq.data(`last-${$el.data('freq').toLowerCase()}-amount`);
                // No custom donation value, then we set the 2nd donation amount options as selected by default
                if (lastFreqAmount) {
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).filter(`[data-amount="${lastFreqAmount}"]`).click();
                } else {
                    // No last stored frequency amount, so click the 2nd amount by default
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).eq(1).click();
                }
            }

            if ($recurringFields.length) {
                $recurringFields.addClass('not-needed');

                if (window.donationTypes && $el.data('freq') === window.donationTypes.Recurring) {
                    $recurringFields.removeClass('not-needed');
                }
            }
        }

        if ($el.data('amount') !== undefined) {
            $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`, $el.data('amount'));
            $donateAmount.val($el.data('amount')).trigger('change');
            $donateCustom.val('');

            // On amount selection, we also change the displaying icon
            if ($iconHolder.length && $el.find('.amount-icon').length) {
                $iconHolder.html($el.find('.amount-icon').html());
            }
        }

        // update ammount on payment form
        if ($amountDesc.length > 0) {
            $amountDesc.text($el.data('amount'));
        }
    });

    // on keyup in custom donation, update donation
    $donateCustom.keyup(function () {
        $donateAmount.val($(this).val());

        // trigger change if error visible
        if ($errorCon.hasClass('has-error')) $donateAmount.trigger('change');

        // Check if we have a valid value in the input, if so, unselect the other options
        if ($(this).val()) {
            $amoutOptions.removeClass('selected');
            $message.html('').parent().removeClass('has-msg');
        }
    });

    // on keyup in custom donation, update donation
    $donateCustom.change(function () {
        $donateAmount.val($(this).val()).trigger('change');
    });
};

// input form field mask
const inputMaskInit = el => {
    // Lets first mask account number if its here
    // @NOTE - here we assume only the account number under debit-form has the jsv-number class
    const $accountNumberInput = $('#debit-form .jsv-number input');
    if ($accountNumberInput.length) {
        Inputmask({
            mask: '999999999',
            placeholder: '',
            showMaskOnFocus: false
        }).mask($accountNumberInput);
    }

    // The rest is masking CC and BSB field
    const ccNumberSelector = 'jsv-ccNumber';
    const bsbNumberSelector = 'jsv-bsb';

    // make sure it run on donation page only
    if ($(`.${ccNumberSelector}`).length === 0) return;

    const $inputMaskCC = $(`.${ccNumberSelector} input`);
    const $inputMaskBSB = $(`.${bsbNumberSelector} input`);
    const dinersTxt = window.cardTypes !== undefined ? window.cardTypes.Diners : 'Diners';
    const amexTxt = window.cardTypes !== undefined ? window.cardTypes.Amex : 'Amex';
    const $ccNumberError = $($inputMaskCC).parents(`.${ccNumberSelector}`).find('.js-error');

    if (!$inputMaskCC.length && !$inputMaskBSB.length) { return; }

    // resetting error message (if any)
    if ($ccNumberError.length > 0) {
        $ccNumberError.removeClass('js-error invalid');
    }

    $($inputMaskCC).val('');

    // need to destroy Inputmask on IOS 9
    Inputmask.remove($inputMaskCC);

    const applyCCMasks = () => {
        if ($(el).val() === dinersTxt) {
            Inputmask({
                mask: '9999 999999 9999 99',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        } else if ($(el).val() === amexTxt) {
            Inputmask({
                mask: '9999 999999 99999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        } else {
            Inputmask({
                mask: '9999 9999 9999 9999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        }
    };

    applyCCMasks();

    Inputmask({
        mask: '999-999',
        placeholder: '',
        showMaskOnFocus: false
    }).mask($inputMaskBSB);

    // remove and reapply mask whilst autofill complete CC details
    $(document).on('keydown', e => {
        // Undefined key on "keydown" means autofill is being used.
        if (typeof e.keyCode === 'undefined') {
            Inputmask.remove($inputMaskCC);
        }
    });
    $(document).on('keyup', e => {
        // Re-initialise inputmask after autofill has done it's job
        if (typeof e.keyCode === 'undefined') {
            applyCCMasks();
        }
    });
};

// Common function to handle submit button click on the donate form - it is used on normal
// js-form-validate button and also any button with recaptcha enabled
// Function made global so it can be used by the google recaptcha callback
window.handleDonateButtonSliderClick = $button => {
    const $form = $('.c-quick-donation-form');
    if ($form.length === 0) return;

    if ($button.hasClass('js-click-to-submit-slider')) {
        const dType = $form.find('.donate-hidden-freq').val();
        const dAmt = $form.find('.donate-hidden-amount').val();
        const hiddenValue = $form.find('.donate-quick-slider').val();

        if (dType !== '' && dAmt !== '') {
            // eslint-disable-next-line
            sessionStorage.setItem('dType', Base64.encode(dType));
            // eslint-disable-next-line
            sessionStorage.setItem('dAmt', Base64.encode(dAmt));

            if (!$button.attr('disabled')) {
                $button.attr('disabled', true);
                $button.removeClass('js-click-to-submit-slider');
                // eslint-disable-next-line
                javascript: __doPostBack('QuickDonate', hiddenValue);
            }
        }
    }
};

// init on submit next button - only the ones without recaptcha enabled
const initSubmitButton = () => {
    const $form = $('.c-quick-donation-form');
    const $submit = $form.find('.js-form-validate').not('.with-recaptcha');
    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();

        const $button = $(e.target);

        // Assign button ID as 'HomepageAction' DT variable's value.
        if ($button.hasClass('js-dl-slide')) {
            const id = $button.attr('id');
            dataLayer.push({ 'HomepageAction': id });
        }

        if (validateForm()) {
            window.handleDonateButtonSliderClick($button);
        }
    });
};

// allow input type number to have maxlength
const initMaxLengthNumber = () => {
    const $numberInput = $('.c-quick-donation-form input[type=number]');
    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const max = $el.attr('maxlength');
        if (max === undefined || max === '') return true;
        if ($el.val().length >= max) return false;
        return true;
    });
};

// validate input to allow number only on keypress, include money (disallow leading zero)
const initNumberOnlyInput = () => {
    const regex = /^\d*\.?\d{0,2}$/;
    const $numberInput = $('.c-quick-donation-form input[type=number]');
    let oldVal = '';

    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;
        const charStr = String.fromCharCode(charCode);
        const val = $el.val().toLowerCase() + charStr.toLowerCase();

        // test digit
        if (regex.test(val)) {
            // test for money format, for intro form only
            if ($el.closest('.donate-amount-input').length > 0) {
                if (val.startsWith('0')) return false;
            }

            return true;
        }

        return false;
    });

    // for money (intro form only)
    $numberInput.keyup(e => {
        const $el = $(e.target);
        const newVal = $el.val();

        if ($el.closest('.donate-amount-input').length > 0) {
            if (newVal.startsWith('0')) {
                $el.val(oldVal);
                return;
            }

            oldVal = newVal;
        }
    });
};

const initDonationForm = () => {
    const $form = $('.c-quick-donation-form');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $recurringFields = $form.find('#recurring-form');

    const $lastDonateAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);

    const donateValue = $lastDonateAmount ? $lastDonateAmount : $donateAmount.val();

    const $donateAmountField = $(`.donate-option[data-amount='${donateValue}']`);

    if ($donateFreq.length <= 0) return;

    // window.globalHelper.orderSessionManager.init();
    window.globalHelper.orderSessionManager.setAppealDonationValues();

    $form.find(`.donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');
    $form.find('.donate-amounts .donate-option').hide();
    $form.find(`.donate-amounts .donate-option[data-freq-mode='${$donateFreq.val()}']`).show();

    if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
    } else {
        $('.donate-amount-input input').val(donateValue).addClass('selected');
    }

    if (window.donationTypes && $donateFreq.val() === window.donationTypes.Recurring) {
        $recurringFields.removeClass('not-needed');
    }
};

const initSingleForm = () => {
    const $singleForm = $('.c-quick-donation-form');

    if (!$singleForm.length) { return; }

    initDonationForm();
};

const initIcon = () => {
    const $form = $('.c-quick-donation-form');
    const $donationIcon = $form.find('.donation-icon');

    if (!$donationIcon.length) { return; }

    const $selectedDonation = $form.find('.donate-option.selected');
    const selectedIcon = $selectedDonation.find('.amount-icon').html();
    const $clonedImage = $(selectedIcon).clone();

    $donationIcon.html('').append($clonedImage);
};

// Funtions calling

$(() => {
    removeKenticoOnclick();
    // keep above first, it has mapping and collection init

    initSingleForm(); // open requested/error form
    initDonationFormUpdateAction(); // on change, click, keyup etc
    initSubmitButton();
    initMaxLengthNumber();
    initNumberOnlyInput();
    inputMaskInit();
    initIcon();
});



// WEBPACK FOOTER //
// ./src/components/quick-donation-form/c-quick-donation-form.js